module.exports = __webpack_public_path__ + "img/036.1efab386.png";